<template>
  <footer class="footer">
    <div class="footer__inner">
        <section class="text-center my2">
          <img src="arborworkslogo.png" alt="Arbor Works Logo" class="footer-logo" />
        </section>
        <p class="copyright">&copy;2024 Arbor Works</p>
        <p class="copyright">All rights reserved</p>
        <p class="mth copyright">
          Built by <a href="https://askchrisn.com" target="_blank" rel="noopener" class="footer-link">AskChris LLC</a>
        </p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  position: relative;
  background-color: var(--primary);
  margin-top: -2rem;
}

.footer-logo {
    background-color: var(--white);
    max-width: 80px;
    height: auto;
}

.footer__inner {
  padding-bottom: 1.5rem;
  background-color: var(--white);
}

.copyright {
  font-size: 0.875rem;
  text-align: center;
  color: var(--primary);
}

.footer-link {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s;
}
.footer-link:hover {
  color: var(--primary, orange); /* or your preferred highlight color */
}

/* DESKTOP */
@media screen and (min-width: 768px) {
  .footer::before {
    height: 10rem;
  }

  .footer-logo {
    max-width: 100px;
    height: auto;
}

}
</style>